<template>
    <div>
        <template v-if="product.thumbnail">
            <!-- <img :src="product.thumbnail" class="img-fluid mx-auto"> -->
            <div
                class="cover-image mx-lg-0 mx-3 d-lg-block d-none"
                :style="{backgroundImage: `url(//cdn.studiesweekly.com/${product.cover_url})`}"
            />
            <div class="d-lg-none d-block w-100 text-center">
                <img
                    :src="product.thumbnail"

                    class="img-fluid cover-image"
                >
            </div>

        </template>

        <template v-if="!product.thumbnail && cover">
            <!-- Large Display --->
            <div class="cover-image cursor-pointer mx-lg-0 mx-3 d-lg-block d-none">
                <b-img fluid-grow center :src="'//cdn.studiesweekly.com/' + cover"
                    class="cover-image" @click="handleClick" />
            </div>

            <!-- Small / Medium Display -->
            <div class="d-lg-none d-block w-100 text-center">
                <b-img
                    :src="'//cdn.studiesweekly.com/' + cover"
                    center
                    fluid-grow
                    class="cover-image cursor-pointer"
                    @click="handleClick"
                />
            </div>
        </template>
        <b-modal id="flipbook-modal" size="xl" centered hide-footer v-if="false">

        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "ProductCover",
    props: ['product'],
    computed: {
        cover() {
            if (this.product.cover_url) {
                return this.product.cover_url;
            }
            let productCover = null

            let sku = null

            if (this.product.sku) {
                let sku2 = this.product.sku.replace(/-(?:SS|SN)-(?:EN|ES)-V[0-9]{1,2}/, "")
                sku2 = sku2.replace(/V[0-9]{2}/, "")
                sku = this.product.sku.replace(/V[0-9]{2}/, "")

                productCover = 'store/products/sku/' + sku + '/OStore-' + sku2 + '-SE-Week1-Page1.jpg'
            }

            return productCover;
        },
        ...mapState({
            publicationResources: state => state.stateData.publicationResources,
        }),
        flipbook() {
            // TODO: flipbook pipeline w/ publicationResources
            return null;
        },
        images() {
            let arr =  Object.assign({},this.publicationResources);
            arr = arr[this.product.sku];
            arr.splice(0, 1)

            return arr;
        }
    },
    methods: {
        handleClick() {
            this.$bvModal.show("flipbook-modal");
        },
        getAspectRatio(image) {
            const w = image.naturalWidth;
            const h = image.naturalHeight;

            let aspectRatio;

            if (w > h) {
                aspectRatio = w / h;
            } else {
                aspectRatio = h / w;
            }

            return aspectRatio;

        }
    }
}
</script>

<style scoped>
.cover-image {
    max-height: 300px;
}
</style>